import * as http from '@/utils/http';
import lockr from 'lockr';

const cacheKey = 'dict_ds';

// initial state
const state = {
  inited: false,
  dicts: {
    online: null,
    jiemo: null,
    college: null,
    job: null,
  },
  datasetDicts: {},
};

// getters
const getters = {
  dictInited: (state) => {
    return state.inited;
  },
  onlineDict: (state) => {
    return state.dicts.online;
  },
  jiemoDict: (state) => {
    return state.dicts.jiemo;
  },
  trainingDict: (state) => {
    return state.dicts.training;
  },
  jobDict: (state) => {
    return state.dicts.job;
  },
  collegeDict: (state) => {
    return state.dicts.college;
  },
  datasetDicts: (state) => {
    return state.datasetDicts;
  },
};

// actions
const actions = {
  fetchDict({ commit }) {
    let dicts = lockr.get(cacheKey);
    if (dicts) {
      commit('setOnlineDict', dicts);
      return true;
    }

    return http._get({
      url: '/index/api_base/getFibDictData'
    }).then(({ data }) => {
      commit('setOnlineDict', data);
      lockr.set(cacheKey, data);
    });
  },
  fetchDataset({ commit }) {
    import('@/dataset/index.js').then((ds) => {
      commit('setDatasetDict', ds);
    });
  },
};

// mutations
const mutations = {
  setOnlineDict(state, dicts) {
    state.inited = true;
    state.dicts = dicts;
  },
  setDatasetDict(state, dicts) {
    state.datasetDicts = dicts;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
